module.exports = __webpack_public_path__ + "img/26_52.3e9d7c30.png";